module.exports = __webpack_public_path__ + "static/media/mastercard.cb4caa21.png";